// hocs/withUserLoading.hoc.tsx
import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Loading } from "components/Common/Loading/Loading";

export const withUserLoading = <T extends object>(
    Component: React.ComponentType<T>
): React.FC<T> => {
    return (props: T) => {
        const isLoading = useSelector((state: any) => state.user?.isLoading);

        if (isLoading) {
            return <Loading />;
        }

        return <Suspense fallback={<Loading />}><Component {...props} /></Suspense>;
    };
};